import styled from 'styled-components';
import { FlexView } from '@cuemath/comps';
import COLORS from 'constants/colors';

export const HeaderContainer = styled(FlexView)`
  border-bottom: 1px solid ${COLORS.GALLERY};
  gap: 16px;
  align-items: flex-start;
`;

export const Divider = styled.span`
  width: 1px;
  align-self: stretch;
  background: ${COLORS.GREY_2};
`;

export const StatusBadge = styled.span`
  padding: 4px 24px;
  border-radius: 8px;
  color: ${({ color }) => color};
  background-color: ${({ bgColor }) => bgColor};
`;

export const ProgressWrapper = styled(FlexView)`
  gap: 12px;
`;

export const ProgressBar = styled(FlexView)`
  width: 160px;
  height: 6px;
  background-color: ${COLORS.GREY_2};
  border-radius: 4px;
  overflow: hidden;
`;

export const ProgressFill = styled(FlexView)`
  height: 100%;
  width: ${({ percent }) => percent}%;
  background-color: ${COLORS.GREEN_5};
  border-radius: 2px;
  transition: width 0.3s ease;
`;
